package com.evoapps.evoshift.ui.kiosk

import com.evoapps.evoshift.widgets.MenuRowCard
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.motionContentSize
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.filled.Pin
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.di.diViewModel
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.viewmodels.KioskPinViewModel
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoTextField
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.kiosk_pin_is_set
import evoshift.composeapp.generated.resources.kiosk_pin_new
import evoshift.composeapp.generated.resources.kiosk_pin_not_set
import evoshift.composeapp.generated.resources.kiosk_pin_remove
import evoshift.composeapp.generated.resources.kiosk_pin_repeat
import evoshift.composeapp.generated.resources.kiosk_pin_save
import evoshift.composeapp.generated.resources.kiosk_pin_text
import evoshift.composeapp.generated.resources.kiosk_pin_title
import org.jetbrains.compose.resources.stringResource

/**
 * SH-107, Profile → "Tablet PIN": whether the person has one, and a dialog to set, change or
 * remove it. The PIN goes to the setKioskPin function, which keeps only a salted hash.
 */
@Composable
fun KioskPinCard(onMessage: suspend (String) -> Unit) {
    val viewModel: KioskPinViewModel = diViewModel()
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    var open by remember { mutableStateOf(false) }

    val message = state.message?.asString()
    LaunchedEffect(message) {
        message?.let {
            open = false
            onMessage(it)
            viewModel.messageShown()
        }
    }

    // SH-158: "Set" / "Not set" unfolds once known instead of pushing the card open.
    MenuRowCard(
        Icons.Default.Pin,
        stringResource(Res.string.kiosk_pin_title),
        onClick = { open = true },
        modifier = Modifier.testTag("kiosk_pin_card"),
        subtitle = state.isSet?.let { set -> stringResource(if (set) Res.string.kiosk_pin_is_set else Res.string.kiosk_pin_not_set) }
    )

    if (open) {
        EvoDialog(
            title = stringResource(Res.string.kiosk_pin_title),
            subtitle = stringResource(Res.string.kiosk_pin_text),
            icon = Icons.Default.Pin,
            onDismiss = { open = false },
            dismissible = !state.isSaving,
            neutral = if (state.isSet == true) DialogAction(stringResource(Res.string.kiosk_pin_remove), viewModel::remove, destructive = true) else null,
            confirm = DialogAction(stringResource(Res.string.kiosk_pin_save), viewModel::save, enabled = state.canSave, loading = state.isSaving)
        ) {
            EvoTextField(
                value = state.pin,
                onValueChange = viewModel::pin,
                label = stringResource(Res.string.kiosk_pin_new),
                keyboardType = KeyboardType.NumberPassword,
                isPassword = true
            )
            EvoTextField(
                value = state.repeat,
                onValueChange = viewModel::repeat,
                label = stringResource(Res.string.kiosk_pin_repeat),
                keyboardType = KeyboardType.NumberPassword,
                isPassword = true,
                imeAction = ImeAction.Done,
                error = state.error?.asString()
            )
        }
    }
}
